import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../../../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

const RejectedEventsContext = createContext();

export const useRejectedEvents = () => useContext(RejectedEventsContext);

export const RejectedEventsProvider = ({ children }) => {
  const [rejectedEvents, setRejectedEvents] = useState([]);

  useEffect(() => {
    let unsubscribeSnapshot = null;

    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      // Reset any existing listener when auth user changes.
      if (typeof unsubscribeSnapshot === 'function') {
        unsubscribeSnapshot();
        unsubscribeSnapshot = null;
      }

      if (!user) {
        setRejectedEvents([]);
        return;
      }

      const eventsRef = collection(db, 'events');
      const q = query(
        eventsRef,
        where('createdBy', '==', user.uid),
        where('status', '==', 'rejected')
      );

      unsubscribeSnapshot = onSnapshot(q, (snapshot) => {
        const rejectedEventsList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setRejectedEvents(rejectedEventsList);
      });
    });

    return () => {
      if (typeof unsubscribeSnapshot === 'function') {
        unsubscribeSnapshot();
      }
      unsubscribeAuth();
    };
  }, []);

  return (
    <RejectedEventsContext.Provider value={{ rejectedEvents, setRejectedEvents }}>
      {children}
    </RejectedEventsContext.Provider>
  );
};
